import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@shared/shared.module';

import { ToolbarModule } from 'primeng/toolbar';
import { SidebarModule } from 'primeng/sidebar';
import { ButtonModule } from 'primeng/button';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { InputSwitchModule } from 'primeng/inputswitch';

import { HeaderComponent } from './components/header/header.component';
import { BreadcrumbsComponent } from './components/breadcrumbs.component';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { UserAvatarComponent } from './components/user-avatar.component';
import { SidebarComponent } from './components/sidebar/sidebar.component';
import { AppNavigationComponent } from './components/app-navigation/app-navigation.component';
import { MenuServicesComponent } from './components/menu-services/menu-services.component';
import { MenuSupportComponent } from './components/menu-support/menu-support.component';
import { NotificationsComponent } from './components/notifications/notifications.component';
import { MenuProfileComponent } from './components/menu-profile/menu-profile.component';
import { MenuGroupComponent } from './components/menu-group/menu-group.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';

@NgModule({
    declarations: [
        HeaderComponent,
        BreadcrumbsComponent,
        ToolbarComponent,
        UserAvatarComponent,
        SidebarComponent,
        AppNavigationComponent,
        MenuServicesComponent,
        MenuSupportComponent,
        NotificationsComponent,
        MenuProfileComponent,
        MenuGroupComponent,
        MobileMenuComponent,
    ],
    exports: [HeaderComponent, BreadcrumbsComponent, SidebarComponent, MobileMenuComponent],
    imports: [
        CommonModule,
        RouterModule,
        SharedModule,

        ToolbarModule,
        ButtonModule,
        BreadcrumbModule,
        SidebarModule,
        OverlayPanelModule,
        InputSwitchModule,
    ],
})
export class LayoutModule {}
